import { render } from "./IpServicoEditPage.vue?vue&type=template&id=10683fe3"
import script from "./IpServicoEditPage.vue?vue&type=script&lang=js"
export * from "./IpServicoEditPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__